import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

export const PopularRoutesSkeleton = () => {
  return (
    <div className={s.container}>
      <Skeleton
        width="250px"
        height="155px"
        duration={0.9}
        borderRadius={'16px'}
      />
      <Skeleton width="250px" />
    </div>
  )
}
